/**
 * i18n Constants
 * Internationalization configuration and defaults
 * @module @infra/i18n
 */

/**
 * Language the app assumes before anyone has chosen one, and the one every other
 * language falls back to for a key it is missing.
 *
 * English, not Vietnamese: it is the language the catalogue is authored in by a wide
 * margin, so a missing string resolves to copy that actually matches the content beside
 * it. Must stay equal to `DEFAULT_LANGUAGE` in sales-coach-core — the two decide what an
 * unspecified language IS, and when they disagreed once, the same blank field resolved
 * differently depending on which side filled it in.
 */
export const I18N_DEFAULT_LANGUAGE = 'en' as const;

/**
 * localStorage key for language preference
 */
export const I18N_LANGUAGE_KEY = 'language' as const;
